import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useLatestTrials } from './useAdminStatus';

interface LatestTrialsCardProps {
    viewerToken?: string;
}

const LatestTrialsCard: React.FC<LatestTrialsCardProps> = ({ viewerToken }) => {
    const { t } = useTranslation();
    const { trials, loading } = useLatestTrials(viewerToken);

    return (
        <div className='dashboard-card admin-list-card'>
            <div className='admin-list-header'>
                <h6 className='title'>{t('dashboard.monitoring.admin.latest_trials.title')}</h6>
            </div>
            {loading ? (
                <div className='admin-status-loading'><div className='loader' /></div>
            ) : trials.length === 0 ? (
                <div className='admin-list-empty'>{t('general.no_data_available')}</div>
            ) : (
                <div className='admin-list-rows'>
                    {trials.map(trial => (
                        <div key={trial.id} className='admin-list-row'>
                            <div className='admin-list-row-main'>
                                <span className='admin-list-row-title'>{trial.company_name}</span>
                                <span className='admin-list-row-subtitle'>
                                    {`${trial.first_name} ${trial.last_name}`.trim()}
                                    {trial.email && ` · ${trial.email}`}
                                </span>
                            </div>
                            <div className='admin-list-row-meta'>
                                <span className='admin-list-row-date'>{dayjs(trial.created).format('DD-MM-YYYY')}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LatestTrialsCard;
